export enum MediaSelectAction {
    None = 'none',
    SelectSingle = 'selectSingle',
    SelectMultiple = 'selectMultiple',
}
